export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiry = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= expiry;
  } catch (e) {
    return true;
  }
};

export const handleTokenExpiration = (error, navigate, dispatch) => {
  if (error?.response?.status === 401 || error?.message?.includes('Unauthorized')) {
    // Clear auth state
    localStorage.removeItem('token');
    dispatch({ type: 'LOGOUT' });
    
    // Redirect to login with return path
    const currentPath = window.location.pathname;
    navigate('/login', { state: { from: currentPath } });
    
    return true;
  }
  return false;
};